import { render } from "./MultiselectTable.vue?vue&type=template&id=b358b878&scoped=true"
import script from "./MultiselectTable.vue?vue&type=script&lang=js"
export * from "./MultiselectTable.vue?vue&type=script&lang=js"

import "./MultiselectTable.vue?vue&type=style&index=0&id=b358b878&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b358b878"]])

export default __exports__